export enum EmployeeFieldsEnum {
	firstName = 'firstName',
	lastName = 'lastName',
	phoneNumber = 'phoneNumber',
	email = 'email',
	accessibleFacilitiesIds = 'accessibleFacilitiesIds',
}
